import { Link } from '@/ui'

export const SUPPORT_EMAIL = 'support@joinheard.com'

export const SupportLink = () => (
  <Link href={`mailto:${SUPPORT_EMAIL}`} newPage>
    {SUPPORT_EMAIL}
  </Link>
)
